import { ICompany } from "../Model/Storage/ICompany";
import { IContact } from "../Model/Storage/IContact";
import { IProject } from "../Model/Storage/IProject";

export function isProject(item: unknown): item is IProject {
  return isType<IProject>(item, `companies`);
}

export function isCompany(item: unknown): item is ICompany {
  return isType<ICompany>(item, `contacts`);
}

export function isContact(item: unknown): item is IContact {
  return item != null && !isProject(item) && !isCompany(item);
}

function isType<T>(item: unknown, prop: string): item is T {
  return item != null && (item as T)[prop] !== undefined;
}
